import React from 'react'
import { ExclamationTriangleIcon, CheckCircleIcon } from '@heroicons/react/24/outline'

export default function GamingVenueCheckPanel({ venueCheck }) {
  if (!venueCheck) return null

  const discrepancy = venueCheck.has_discrepancy

  return (
    <div className={`rounded-lg border p-4 text-sm ${
      discrepancy ? 'border-amber-300 bg-amber-50 text-amber-950' : 'border-green-200 bg-green-50 text-green-900'
    }`}>
      <div className="flex gap-2 items-start">
        {discrepancy
          ? <ExclamationTriangleIcon className="w-5 h-5 shrink-0 text-amber-600" />
          : <CheckCircleIcon className="w-5 h-5 shrink-0 text-green-600" />}
        <div className="flex-1 min-w-0">
          <p className="font-medium">
            {discrepancy ? 'Venue name mismatch' : 'Venue names match configuration'}
          </p>
          {venueCheck.warning && (
            <p className="mt-1 text-xs">{venueCheck.warning}</p>
          )}
        </div>
      </div>

      <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-3 text-xs">
        <div>
          <p className="font-medium text-gray-700 mb-1">In file (sample)</p>
          {venueCheck.file_venue_names?.length ? (
            <ul className="list-disc list-inside space-y-0.5">
              {venueCheck.file_venue_names.map((name) => (
                <li key={name} className="font-mono">
                  {name}
                  {venueCheck.unmatched_file_venues?.includes(name) && (
                    <span className="text-amber-800 ml-1">— no match</span>
                  )}
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-gray-500">No site names detected in sample</p>
          )}
        </div>
        <div>
          <p className="font-medium text-gray-700 mb-1">Configured venues</p>
          {venueCheck.configured_venues?.length ? (
            <ul className="space-y-1">
              {venueCheck.configured_venues.map((v) => (
                <li key={v.venue_id}>
                  <span className="font-medium">{v.name}</span>
                  {v.gaming_extract_venue_name && (
                    <span className="text-gray-600"> · extract: {v.gaming_extract_venue_name}</span>
                  )}
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-gray-500">No venues in tenant — add venues in Admin</p>
          )}
        </div>
      </div>

      {venueCheck.configured_venues_not_in_file?.length > 0 && (
        <p className="mt-2 text-xs text-gray-600">
          Not in file sample: {venueCheck.configured_venues_not_in_file.map((v) => v.name).join(', ')}
        </p>
      )}

      {discrepancy && (
        <p className="mt-2 text-xs text-amber-900">
          Update <strong>Gaming extract name</strong> on each venue (Admin → Venues) to match the site label in the extract file, or filter the file to the intended site before ingest.
        </p>
      )}
    </div>
  )
}
